import { Action } from '@ngrx/store';
import { OpbCompanySearchFilter } from '../../models/opbCompanySearchFilter';

export enum EOpbCompanyListActions {
  SetSearchFilter = '[OPB Company List] SET SEARCH FILTER',
  SetPagination = '[OPB Company List] SET PAGINATION',
  SetSort = '[OPB Company List] SET SORT',
  ClearFilters = '[OPB Company List] CLEAR FILTERS'
}

export class SetOpbCompanySearchFilter implements Action {
  public readonly type = EOpbCompanyListActions.SetSearchFilter;
  constructor(public payload: OpbCompanySearchFilter) {}
}

export class SetOpbCompanyPagination implements Action {
  public readonly type = EOpbCompanyListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetOpbCompanySort implements Action {
  public readonly type = EOpbCompanyListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearOpbCompanyFilters implements Action {
  public readonly type = EOpbCompanyListActions.ClearFilters;
}

export type OpbCompanyListActions =
  | SetOpbCompanySearchFilter
  | SetOpbCompanyPagination
  | SetOpbCompanySort
  | ClearOpbCompanyFilters;
